import React from "react";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import Dashboard from "./Dashboard/Dashboard";
import AuthPage from "./auth/AuthPage";

export default ({ childProps }) =>
<Router>
  <div>
    <Route exact path="/" render={() => (
       childProps.isAuthenticated ? (
        <Dashboard {...childProps}/>
      ) : (
        <AuthPage childProps={childProps}/>
      )
      )}/>
    <Route path="/signin" render={() => <AuthPage childProps={childProps} />} />
  </div>
</Router>



// WEBPACK FOOTER //
// ./src/components/Routes.js